// Agency white-label settings. Super-admin only.
// Configured branding applies to every sub-account owned by this agency
// (matched via accounts.whitelabel_parent_account_id, set automatically on save).
import React, { useEffect, useState } from 'react';
import { G, styles, api } from '../theme.js';
import { Btn, Field, Input, Spinner } from '../ui.jsx';

export function AgencyBranding({ toast }) {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api('/api/agency/branding').then(setF).catch(()=>setF({}));
  useEffect(() => { load(); }, []);
  if (!f) return <Spinner sz={32}/>;

  const save = async () => {
    setBusy(true);
    try { await api('/api/agency/branding', { method:'PATCH', body: f }); toast('✓ Branding saved · sub-accounts will pick this up on next load'); }
    catch (e) { toast(e.message, 'error'); }
    finally { setBusy(false); }
  };

  return <div style={{ padding:24, maxWidth:900 }}>
    <h1 style={{ margin:'0 0 8px', fontSize:24, fontWeight:800 }}>🎨 Agency Branding (White-label)</h1>
    <div style={{ color:G.textMuted, fontSize:14, marginBottom:20 }}>
      Rebrand the platform for your sub-accounts. Logo + name + colors + support email auto-apply to every sub-account you own. Sell it as <strong>your</strong> product, not TradeOps.
    </div>

    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:18 }}>
      <div style={{ ...styles.card, padding:20 }}>
        <h3 style={{ margin:'0 0 14px', fontSize:15 }}>Brand identity</h3>
        <Field label="Brand name" hint="Replaces 'TradeOps' everywhere your sub-accounts see it">
          <Input value={f.brandName||''} onChange={e=>setF({...f, brandName:e.target.value})} placeholder="e.g. Acme Agency CRM"/>
        </Field>
        <Field label="Logo URL" hint="Use a wide horizontal logo (PNG with transparency works best)">
          <Input value={f.logoUrl||''} onChange={e=>setF({...f, logoUrl:e.target.value})} placeholder="https://your-cdn.com/logo.png"/>
        </Field>
        {f.logoUrl && <div style={{ background:'#fff', padding:14, borderRadius:8, marginBottom:10, textAlign:'center' }}><img src={f.logoUrl} alt="" style={{ maxHeight:60 }}/></div>}
        <Field label="Favicon URL"><Input value={f.faviconUrl||''} onChange={e=>setF({...f, faviconUrl:e.target.value})} placeholder="https://your-cdn.com/favicon.ico"/></Field>
        <Field label="Primary brand color">
          <Input type="color" value={f.primaryColor||'#a78bfa'} onChange={e=>setF({...f, primaryColor:e.target.value})}/>
        </Field>
      </div>

      <div style={{ ...styles.card, padding:20 }}>
        <h3 style={{ margin:'0 0 14px', fontSize:15 }}>Support + access</h3>
        <Field label="Support email" hint="Where sub-account owners reach out for help">
          <Input value={f.supportEmail||''} onChange={e=>setF({...f, supportEmail:e.target.value})} placeholder="support@youragency.com"/>
        </Field>
        <Field label="App subdomain (optional)" hint="Point your-subdomain.flowtradeopsautomation.com here. Custom domains coming soon.">
          <Input value={f.appSubdomain||''} onChange={e=>setF({...f, appSubdomain:e.target.value})} placeholder="acme"/>
        </Field>
        <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, color:G.textMuted, cursor:'pointer', marginTop:10 }}>
          <input type="checkbox" checked={!!f.hidePoweredBy} onChange={e=>setF({...f, hidePoweredBy:e.target.checked})}/>
          Hide "Powered by TradeOps" from sub-account UIs
        </label>
      </div>
    </div>

    <div style={{ ...styles.card, padding:20, marginTop:18, background:G.input }}>
      <strong style={{ fontSize:13 }}>How this looks to a sub-account owner</strong>
      <div style={{ display:'flex', alignItems:'center', gap:14, marginTop:12 }}>
        {f.logoUrl
          ? <img src={f.logoUrl} alt="" style={{ height:34 }}/>
          : <div style={{ fontSize:18, fontWeight:800, background:`linear-gradient(135deg,${f.primaryColor||'#a78bfa'},#22d3ee)`, WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>{f.brandName || 'TradeOps'}</div>}
        <span style={{ color:G.textMuted, fontSize:12 }}>· Login screen + sidebar + email FROM</span>
      </div>
    </div>

    <div style={{ display:'flex', justifyContent:'flex-end', marginTop:18 }}>
      <Btn v="primary" onClick={save} disabled={busy}>{busy ? <Spinner sz={14}/> : '💾 Save branding'}</Btn>
    </div>
  </div>;
}
